export const CERTIFICATION_LEVELS = [
     { id: 'both', name: 'Both' },
     { id: 'trained', name: 'CAMS Trained' },
     { id: 'certificated', name: 'CAMS Certified' },
];

export const PREREQUISITE_CERTIFICATION_LEVELS = [
     { value: 'trained', label: 'CAMS Trained' },
     // { value: 'teens-trained', label: 'CAMS Teen Trained' },
     { value: 'certificated', label: 'CAMS Certified' },
];

export const DESIGNATION_ELEMENT_TABS = {
     GENERAL: 'general',
     REQUIREMENTS: 'requirements',
     USER_ACCESS: 'user_access',
     EXPIRATION: 'expiration',
};

export const REQUIREMENT_TYPES = [
     { id: 'product', name: 'LearnDash Course' },
     { id: 'professional', name: 'Professional Field' },
];

export const SET_CONDITION_FIELD_VALUE_OPTIONS = [
     { id: 'yes', name: 'Yes' },
     { id: 'no', name: 'No' },
];

export const SET_CONDITION_FIELD_EVENT_CALL_VALUE_OPTIONS = [{ id: '4ValuesArePresent', name: '4 Values Are Present' }];

export const SET_RULE_CONDITION_OPTIONS = [
     { id: 'theFieldIsCurrentlyNull', name: 'The field is currently null' },
     { id: 'alwaySetValue', name: 'Alway Set Value' },
];

export const SET_RULE_VALUE_OPTIONS = [
     { id: 'yes', name: 'Yes' },
     { id: 'todayDate', name: "Today's Date" },
     { id: 'courseId', name: 'Course ID - add to existing list in field' },
];

export const CERTIFICATION_LEVEL_RULES = [
     {
          fieldId: 'rolePlayTraining',
          name: 'Role Play Training',
          userHasAccess: true,
          requirementType: 'product',
          fieldRequirementComplete: ['rolePlayTraining.completed', 'rolePlayTraining.completionDate'],
     },
     {
          fieldId: 'consultationCalls',
          name: 'Consultation Calls',
          requirementType: 'both',
          fieldRequirementComplete: [
               'consultationCalls.consultationAttendedCalls',
               'consultationCalls.completed',
               'consultationCalls.completionDate',
          ],
     },
     {
          fieldId: 'licensingDocumentationCertification',
          name: 'Licensing Documentation',
          hasExpiration: true,
          requirementType: 'professional',
          fieldRequirementComplete: [
               'licensingDocumentationCertification.adminHasReviewed',
               'licensingDocumentationCertification.completed',
               'licensingDocumentationCertification.completionDate',
          ],
          fieldExpirationComplete: [
               'licensingDocumentationCertification.completed',
               'licensingDocumentationCertification.expirationDate',
               'licensingDocumentationCertification.completionDate',
               'licensingDocumentationCertification.manuallyOverrideCompletionStatus',
               'licensingDocumentationCertification.manuallySetCompletionStatus',
               'licensingDocumentationCertification.adminHasReviewed',
          ],
     },
     {
          fieldId: 'readTheBook',
          name: 'Read the Book',
          requirementType: 'product',
          fieldRequirementComplete: ['readTheBook.completed', 'readTheBook.completionDate'],
     },
     {
          fieldId: 'zipCodeLocatorConsent',
          name: 'Clinician Locator Consent',
          requirementType: 'professional',
          fieldRequirementComplete: [
               'zipCodeLocatorConsent.zipCodeConsent',
               'zipCodeLocatorConsent.completed',
               'zipCodeLocatorConsent.completionDate',
          ],
     },
     {
          fieldId: 'bookCeuCert',
          name: 'Book CEs',
          userHasAccess: true,
          requirementType: 'product',
          fieldRequirementComplete: ['bookCeuCert.completed', 'bookCeuCert.completionDate'],
     },
     {
          fieldId: 'teensVideo',
          name: 'Teens Online Video Course',
          userHasAccess: true,
          hasExpiration: true,
          requirementType: 'product',
          fieldRequirementComplete: ['teensVideo.completed', 'teensVideo.completionDate'],
          fieldExpirationComplete: [
               'teensVideo.completed',
               'teensVideo.expirationDate',
               'teensVideo.completionDate',
               'teensVideo.manuallyOverrideCompletionStatus',
               'teensVideo.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'teensCeu',
          name: 'Teens Course CEs',
          userHasAccess: true,
          requirementType: 'product',
          fieldRequirementComplete: ['teensCeu.completed', 'teensCeu.completionDate'],
     },
     {
          fieldId: 'patientDocumentation',
          name: 'Review of Completed Suicide Status Forms',
          hasExpiration: true,
          requirementType: 'professional',
          fieldRequirementComplete: [
               'patientDocumentation.adminHasReviewed',
               'patientDocumentation.completed',
               'patientDocumentation.completionDate',
          ],
          fieldExpirationComplete: [
               'patientDocumentation.completed',
               'patientDocumentation.expirationDate',
               'patientDocumentation.completionDate',
               'patientDocumentation.manuallyOverrideCompletionStatus',
               'patientDocumentation.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'professionalDocumentation',
          name: 'Suicide Specific Professional Experience',
          hasExpiration: true,
          requirementType: 'professional',
          fieldRequirementComplete: [
               'professionalDocumentation.adminHasReviewed',
               'professionalDocumentation.completed',
               'professionalDocumentation.completionDate',
          ],
          fieldExpirationComplete: [
               'professionalDocumentation.completed',
               'professionalDocumentation.expirationDate',
               'professionalDocumentation.completionDate',
               'professionalDocumentation.manuallyOverrideCompletionStatus',
               'professionalDocumentation.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'difficultVideo',
          name: 'Difficult Cases Online Video Course',
          userHasAccess: true,
          hasExpiration: true,
          requirementType: 'product',
          fieldRequirementComplete: ['difficultVideo.completed', 'difficultVideo.completionDate'],
          fieldExpirationComplete: [
               'difficultVideo.completed',
               'difficultVideo.expirationDate',
               'difficultVideo.completionDate',
               'difficultVideo.manuallyOverrideCompletionStatus',
               'difficultVideo.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'difficultCeu',
          name: 'Difficult Cases Course CEs',
          userHasAccess: true,
          hasExpiration: true,
          requirementType: 'product',
          fieldRequirementComplete: ['difficultCeu.completed', 'difficultCeu.completionDate'],
          fieldExpirationComplete: [
               'difficultCeu.completed',
               'difficultCeu.expirationDate',
               'difficultCeu.completionDate',
               'difficultCeu.manuallyOverrideCompletionStatus',
               'difficultCeu.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'malpracticeCeu',
          name: 'Malpractice Issues Course CEs',
          userHasAccess: true,
          hasExpiration: true,
          requirementType: 'product',
          fieldRequirementComplete: ['malpracticeCeu.completed', 'malpracticeCeu.completionDate'],
          fieldExpirationComplete: [
               'malpracticeCeu.completed',
               'malpracticeCeu.expirationDate',
               'malpracticeCeu.completionDate',
               'malpracticeCeu.manuallyOverrideCompletionStatus',
               'malpracticeCeu.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'malpracticeCourse',
          name: 'Malpractice Issues Online Video Course',
          userHasAccess: true,
          hasExpiration: true,
          requirementType: 'product',
          fieldRequirementComplete: ['malpracticeCourse.completed', 'malpracticeCourse.completionDate'],
          fieldExpirationComplete: [
               'malpracticeCourse.completed',
               'malpracticeCourse.expirationDate',
               'malpracticeCourse.completionDate',
               'malpracticeCourse.manuallyOverrideCompletionStatus',
               'malpracticeCourse.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'camsVideo',
          name: 'Online Foundational Video Course',
          userHasAccess: true,
          hasExpiration: true,
          requirementType: 'product',
          fieldRequirementComplete: [
               'camsVideo.completed',
               'annualRefresher.completed',
               'camsVideo.completionDate',
               'annualRefresher.completionDate',
          ],
          fieldExpirationComplete: [
               'annualRefresher.completed',
               'annualRefresher.completionDate',
               'annualRefresher.manuallyOverrideCompletionStatus',
               'annualRefresher.manuallySetCompletionStatus',
          ],
     },
     {
          fieldId: 'camsVideoCeu',
          name: 'Foundational Video CEU',
          userHasAccess: true,
          requirementType: 'product',
          fieldRequirementComplete: ['camsVideoCeu.completed', 'camsVideoCeu.completionDate'],
     },
     {
          fieldId: 'annualRefresher',
          name: 'Annual CAMS Foundation Refresher',
          userHasAccess: true,
          hasExpiration: true,
          requirementType: 'product',
          fieldRequirementComplete: [
               'annualRefresher.completed',
               'annualRefresher.completionDate',
               'annualRefresher.courseIdsAlreadyUtilizedForRequirement',
          ],
          fieldExpirationComplete: [
               'annualRefresher.access',
               'annualRefresher.completed',
               'annualRefresher.expirationDate',
               'annualRefresher.completionDate',
               'annualRefresher.manuallyOverrideCompletionStatus',
               'annualRefresher.manuallySetCompletionStatus',
          ],
     },
];

export const EXPIRATION_FIELD_VALUES = {
     NO: 'No',
     NULL_CLEAR_FIELDS: 'null-clear fields current value',
};

export const FIELDS_UPDATE_REQUIREMENT_COMPLETE = {
     access: 'Access',
     adminHasReviewed: 'Admin Has Reviewed',
     completed: 'Completed',
     completionDate: 'Completion Date',
     confirmReadTheBook: 'Confirm Read the Book',
     consultationAttendedCalls: 'Consultation Attended Calls',
     courseIdsAlreadyUtilizedForRequirement: 'Course Ids Already Utilized For Requirement',
     expirationDate: 'Expiration Date',
     manuallyOverrideCompletionStatus: 'Manually Override Completion Status',
     manuallySetCompletionStatus: 'Manually Set Completion Status',
     zipCodeConsent: 'Zip Code Consent',
};

export const FIELDS_NAME_REQUIREMENT_COMPLETE = {
     annualRefresher: 'Annual CAMS Foundation Refresher',
     bookCeuCert: 'Book CEs',
     camsVideo: 'CAMS Foundational Video',
     camsVideoCeu: 'CAMS Foundational CE',
     consultationCalls: 'Consultation Calls',
     difficultCeu: 'Difficult Cases Course CEs',
     difficultVideo: 'Difficult Cases Online Video Course',
     licensingDocumentationCertification: 'Licensing Documentation',
     malpracticeCeu: 'Malpractice Issues Course CEs',
     malpracticeCourse: 'Malpractice Issues Online Video Course',
     patientDocumentation: 'CAMS Professional Practice',
     professionalDocumentation: 'Suicide Specific Professional Experience',
     readTheBook: 'Read the Book',
     rolePlayTraining: 'Role Play Training',
     teensCeu: 'Teens Course CEs',
     teensVideo: 'Teens Online Video Course',
     zipCodeLocatorConsent: 'Clinician Locator Consent',
};

export const RULE_REQUIREMENT_KEY = {
     ADMIN_HAS_REVIEWED: 'adminHasReviewed',
     ALWAY_SET_VALUE: 'alwaySetValue',
     ANNUAL_REFRESHER: 'annualRefresher',
     CAMS_VIDEO: 'camsVideo',
     COMPLETED: 'completed',
     CONFIRM_READ_THE_BOOK: 'confirmReadTheBook',
     COURSE_ID: 'courseId',
     COURSE_IDS_ALREADY_UTILIZED_FOR_REQUIREMENT: 'courseIdsAlreadyUtilizedForRequirement',
     DATE: 'Date',
     MANUALLY_SET_COMPLETION: 'manuallySetCompletion',
     ROLE_PLAY_TRAINING: 'rolePlayTraining',
     THE_FIELD_IS_CURRENTLY_NULL: 'theFieldIsCurrentlyNull',
     TODAY_DATE: 'todayDate',
     YES: 'yes',
};

export const REQUIREMENT_TYPE = {
     PRODUCT: 'product',
     PROFESSIONAL: 'professional',
};

export const CERTIFICATION_ACTION_TYPE = {
     CLEAR: 'clear',
     UPDATE: 'update',
};

export const CERTIFICATION_LEVEL = {
     BOTH: 'both',
     TRAINED: 'trained',
     CERTIFICATED: 'certificated',
};

export const USER_CERTIFICATION_LEVEL_MODEL = {
     None: 'none',
     Trained: 'trained',
     Certified: 'certificated',
};

export const USER_CERTIFICATION_LEVEL_LABEL = {
     none: 'None',
     trained: 'CAMS Trained',
     certificated: 'CAMS Certified',
};

export const DESIGNATION_ELEMENT_FIELD_GROUPS = [
     {
          name: 'General',
          fields: [
               'name',
               'publishName',
               'genericPublicName',
               'status',
               'description',
               'relatedProductPageToPurchase',
               'relatedProductPageToComplete',
               'relatedProductLinkToCompleteProfessionalField',
               'categoryLv1',
               'categoryLv2',
          ],
     },
     {
          name: 'Requirements',
          fields: ['requirementCertificationLevels', 'requirementType', 'conditions', 'rules'],
     },
     {
          name: 'User Access',
          fields: ['userAccessStatus', 'userFieldToSaveUserAccessValueTo'],
     },
     {
          name: 'Expiration',
          fields: ['expirationStatus', 'daysUntilExpiration', 'userFieldToSaveExpirationDateValueTo', 'userFieldsUpdatedWhenExpiration'],
     },
];

export const LIST_FIELD_REQUIRED = [
     {
          field: 'name',
          label: 'Admin Name',
     },
     {
          field: 'publishName',
          label: 'Detailed Public Name',
     },
     {
          field: 'genericPublicName',
          label: 'Generic Public Name',
     },
     {
          field: 'requirementCertificationLevels',
          label: 'Certification Levels',
     },
     {
          field: 'requirementType',
          label: 'Requirement Type',
     },
     {
          field: 'useCompletionDate',
          label: 'useCompletionDate',
     },
     {
          field: 'useExpirationDate',
          label: 'useExpirationDate',
     },
     {
          field: 'useManuallySetCompletionStatus',
          label: 'useManuallySetCompletionStatus',
     },
     {
          field: 'useManualOverrideCompletionStatus',
          label: 'useManualOverrideCompletionStatus',
     },
     {
          field: 'useProductsAlreadyUtilizedForRequirement',
          label: 'useProductsAlreadyUtilizedForRequirement',
     },
     {
          field: 'useUserAttendedRolePlay',
          label: 'useUserAttendedRolePlay',
     },
     {
          field: 'useUserHasAccess',
          label: 'useUserHasAccess',
     },
     {
          field: 'useUserHasCompletedRequirement',
          label: 'useUserHasCompletedRequirement',
     },
     {
          field: 'userFieldToSaveUserAccessValueTo',
          label: 'Save User Access Value To',
          condition: {
               field: 'userAccessStatus',
               value: 'yes',
          },
     },
     {
          field: 'daysUntilExpiration',
          label: 'Days Until Expiration',
          condition: {
               field: 'expirationStatus',
               value: 'yes',
          },
     },
     {
          field: 'userFieldToSaveExpirationDateValueTo',
          label: 'User Field To Save Expiration Date Value To',
          condition: {
               field: 'expirationStatus',
               value: 'yes',
          },
     },
     {
          field: 'userFieldsUpdatedWhenExpiration',
          label: 'Save Status Field ID',
          condition: {
               field: 'expirationStatus',
               value: 'yes',
          },
     },
];

export const CONSULTATION_CALL_VALUE = 'consultationAttendedCalls';

export const PRESENT_CALL_VALUE = '4ValuesArePresent';
